import aes from 'crypto-js/aes';

function doEncrypt(data) {
  const token = aes.encrypt(data, process.env.VUE_APP_AUTH_COOKIE_SECRET).toString();
  return token;
}

export default doEncrypt;
